import { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import { useChatStore } from '../../store/chatStore'
import { useAuthStore } from '../../store/authStore'
import { getMessages, sendMessage, editMessage, reactToMessage } from '../../lib/api'
import { useZumoWebSocket } from '../../hooks/useZumoWebSocket'
import ChatHeader from './ChatHeader'
import MessageList from './MessageList'
import MessageInput from './MessageInput'

export default function ChatView({ onBack }: { onBack: () => void }) {
  const { activeConversation, setMessages, addMessage } = useChatStore()
  const { user } = useAuthStore()
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [replyTo, setReplyTo] = useState<any>(null)
  const [editingMsg, setEditingMsg] = useState<any>(null)
  const [typingUsers, setTypingUsers] = useState<string[]>([])
  const { sendWS } = useZumoWebSocket()

  const convo = activeConversation
  const roomId = convo?.id
  const name = convo?.title || 'Chat'

  useEffect(() => {
    const h = (e: Event) => {
      const d = (e as CustomEvent).detail
      if (d.conversation_id === roomId) setTypingUsers(p => d.is_typing ? [...new Set([...p, d.username])] : p.filter(u => u !== d.username))
    }
    window.addEventListener('typing', h); return () => window.removeEventListener('typing', h)
  }, [roomId])

  useEffect(() => {
    if (roomId) { setLoading(true); getMessages(roomId, 100).then(d => { if (d.messages) setMessages(roomId, d.messages) }).finally(() => setLoading(false)) }
  }, [roomId])

  const handleSend = async () => {
    if (!input.trim() || !roomId || !user) return
    const text = input.trim(); setInput('')
    if (editingMsg) { try { await editMessage(editingMsg.id, text) } catch {}; setEditingMsg(null); return }
    const tempId = `t-${Date.now()}`
    addMessage(roomId, { id: tempId, room_id: roomId, sender_id: user.uid, username: user.username, text, type: 'text', reply_to: replyTo?.id, created_at: Date.now(), status: 'sent' })
    try { await sendMessage(roomId, text, { reply_to_id: replyTo?.id }); sendWS('message', { text, reply_to_id: replyTo?.id }) } catch {}
    setReplyTo(null)
  }

  const handleTyping = (v: string) => { setInput(v); if (roomId) sendWS('typing', { room_id: roomId, is_typing: v.length > 0 }) }
  const handleReact = async (msgId: string, emoji: string) => { try { await reactToMessage(msgId, emoji) } catch {} }

  return (
    <motion.div initial={{ x: 300, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: 300, opacity: 0 }}
      transition={{ type: 'spring', damping: 25, stiffness: 300 }} className="chat-screen grid-bg">
      <ChatHeader name={name} isGroup={convo?.type === 'group'} memberCount={convo?.members?.length} typingUsers={typingUsers} onBack={onBack} />
      <MessageList loading={loading} onReply={setReplyTo} onReact={handleReact} />
      <MessageInput value={input} onChange={handleTyping} onSend={handleSend} replyTo={replyTo} editingMsg={editingMsg} onCancelContext={() => { setReplyTo(null); setEditingMsg(null) }} />
    </motion.div>
  )
}
